// M12 等差數列與等比數列 - 主題 03-10 數據文件
// Topics 03-10: 公差計算, 方程求解, 交錯級數, 因數分解, 折舊計算, 求和公式

// M12_03: 公差計算 (5題)
export const M12_03_PROBLEMS = [
  {
    id: 'M12_03_P001',
    topicId: 'M12_03',
    type: 'multi_part',
    difficulty: 'basic',
    question: '等差數列 {aₙ} 的公差計算：',
    parts: {
      a: 'a₃ = 7，a₇ = 15',
      b: '求公差 d',
      c: '求首項 a₁ 和通項公式'
    },
    solution: {
      a: '設通項公式為 aₙ = a₁ + (n-1)d\n由條件：a₃ = a₁ + 2d = 7，a₇ = a₁ + 6d = 15',
      b: '兩式相減：(a₁ + 6d) - (a₁ + 2d) = 15 - 7\n4d = 8，所以 d = 2',
      c: '代回 a₃ = 7：a₁ + 2(2) = 7，所以 a₁ = 3\n通項公式：aₙ = 3 + (n-1)×2 = 2n + 1'
    },
    hint: {
      a: '利用等差數列通項公式',
      b: '通過項的差值求公差',
      c: '先求首項，再寫通項公式'
    },
    tags: ['等差數列', '公差', '通項公式'],
    difficulty: 1,
    order: 1
  },
  {
    id: 'M12_03_P002',
    topicId: 'M12_03',
    type: 'multi_part',
    difficulty: 'basic',
    question: '等差數列的條件分析：',
    parts: {
      a: 'a₁ + a₃ + a₅ = 12，a₂ + a₄ + a₆ = 18',
      b: '判斷是否為等差數列並求公差',
      c: '求 a₇ 的值'
    },
    solution: {
      a: '設首項為 a₁，公差為 d\na₁ + a₃ + a₅ = a₁ + (a₁ + 2d) + (a₁ + 4d) = 3a₁ + 6d = 12',
      b: 'a₂ + a₄ + a₆ = (a₁ + d) + (a₁ + 3d) + (a₁ + 5d) = 3a₁ + 9d = 18\n從第一式：a₁ + 2d = 4\n從第二式：a₁ + 3d = 6\n相減得：d = 2',
      c: '代入得 a₁ = 0，通項公式：aₙ = 2(n-1)\na₇ = 2×6 = 12'
    },
    hint: {
      a: '利用通項公式表示各項',
      b: '建立方程組求解',
      c: '用通項公式計算'
    },
    tags: ['等差數列', '公差', '聯立方程'],
    difficulty: 1,
    order: 2
  },
  {
    id: 'M12_03_P003',
    topicId: 'M12_03',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等差數列前三項的關係：',
    parts: {
      a: '前三項為 2x-1, x+3, 2x-9',
      b: '求 x 的值',
      c: '求該數列的公差和前10項和'
    },
    solution: {
      a: '等差數列性質：中間項等於前後兩項的平均\n即 x+3 = [(2x-1) + (2x-9)]/2',
      b: '化簡：2(x+3) = 4x - 10\n2x + 6 = 4x - 10\n16 = 2x，所以 x = 8',
      c: '三項為：15, 11, 7，公差 d = -4\nS₁₀ = 10/2 × [2×15 + 9×(-4)] = 5 × (30 - 36) = -30'
    },
    hint: {
      a: '等差數列中項性質',
      b: '解一元一次方程',
      c: '用求和公式計算'
    },
    tags: ['等差數列', '公差', '前n項和'],
    difficulty: 2,
    order: 3
  },
  {
    id: 'M12_03_P004',
    topicId: 'M12_03',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等差數列的遞推關係：',
    parts: {
      a: 'a₁ = 3，第n項與第(n+3)項的差為12',
      b: '求公差 d',
      c: '求通項公式和第15項'
    },
    solution: {
      a: '由條件：aₙ₊₃ - aₙ = 12\n利用通項公式：aₙ₊₃ = a₁ + (n+2)d，aₙ = a₁ + (n-1)d',
      b: 'aₙ₊₃ - aₙ = [a₁ + (n+2)d] - [a₁ + (n-1)d] = 3d = 12\n因此 d = 4',
      c: '通項公式：aₙ = 3 + (n-1)×4 = 4n - 1\na₁₅ = 4×15 - 1 = 59'
    },
    hint: {
      a: '理解項間差值關係',
      b: '利用通項公式求差',
      c: '建立通項公式'
    },
    tags: ['等差數列', '公差', '遞推關係'],
    difficulty: 2,
    order: 4
  },
  {
    id: 'M12_03_P005',
    topicId: 'M12_03',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '等差數列的性質證明：',
    parts: {
      a: '證明：若 {aₙ} 為等差數列，則 a₁ + aₙ = a₂ + aₙ₋₁ = ... = aₖ + aₙ₋ₖ₊₁',
      b: '利用此性質計算：a₁ + a₂₀ = 42，求 a₁₀ + a₁₁',
      c: '若 S₂₀ = 420，求公差 d'
    },
    solution: {
      a: '設公差為 d，則：\naₖ + aₙ₋ₖ₊₁ = [a₁ + (k-1)d] + [a₁ + (n-k)d]\n= 2a₁ + (n-1)d = a₁ + aₙ\n因此各項對之和相等',
      b: '由對稱性質：a₁ + a₂₀ = a₁₀ + a₁₁ = 42',
      c: 'S₂₀ = 20/2 × (a₁ + a₂₀) = 10 × 42 = 420 ✓\n由 a₁ + a₂₀ = 42 和 a₂₀ = a₁ + 19d\n得：2a₁ + 19d = 42\n又 S₂₀ = 20a₁ + 190d = 420，即 a₁ + 9.5d = 21\n解得：d = 2，a₁ = 2'
    },
    hint: {
      a: '利用通項公式證明對稱性',
      b: '應用對稱性質',
      c: '結合求和公式求解'
    },
    tags: ['等差數列', '公差', '對稱性質'],
    difficulty: 3,
    order: 5
  }
];

// M12_04: 方程求解 (5題)
export const M12_04_PROBLEMS = [
  {
    id: 'M12_04_P001',
    topicId: 'M12_04',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '數列方程的建立與求解：',
    parts: {
      a: '等差數列 {aₙ} 中，S₁₀ = 120，S₂₀ = 440',
      b: '建立關於 a₁ 和 d 的方程組',
      c: '求 a₁、d 和 S₃₀'
    },
    solution: {
      a: '使用前n項和公式：Sₙ = n/2 × [2a₁ + (n-1)d]\nS₁₀ = 5[2a₁ + 9d] = 120\nS₂₀ = 10[2a₁ + 19d] = 440',
      b: '方程組：\n2a₁ + 9d = 24 ... ①\n2a₁ + 19d = 44 ... ②',
      c: '②-①：10d = 20，所以 d = 2\n代回①：2a₁ + 18 = 24，所以 a₁ = 3\nS₃₀ = 15[2×3 + 29×2] = 15×64 = 960'
    },
    hint: {
      a: '使用前n項和公式',
      b: '建立線性方程組',
      c: '求解方程組並計算'
    },
    tags: ['等差數列', '方程組', '前n項和'],
    difficulty: 2,
    order: 1
  },
  {
    id: 'M12_04_P002',
    topicId: 'M12_04',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等比數列的方程求解：',
    parts: {
      a: '等比數列 {aₙ} 中，S₃ = 26，S₆ = 728',
      b: '求首項 a₁ 和公比 r',
      c: '求 S₉'
    },
    solution: {
      a: '設 Sₙ = a₁(rⁿ - 1)/(r - 1)\nS₃ = a₁(r³ - 1)/(r - 1) = 26\nS₆ = a₁(r⁶ - 1)/(r - 1) = 728',
      b: '注意：r⁶ - 1 = (r³ - 1)(r³ + 1)\n所以 S₆/S₃ = (r³ + 1) = 728/26 = 28\n因此 r³ = 27，r = 3\n代入：a₁ × 26/2 = 26，所以 a₁ = 2',
      c: 'S₉ = 2(3⁹ - 1)/(3 - 1) = (19683 - 1) = 9841'
    },
    hint: {
      a: '寫出前n項和公式',
      b: '利用項間關係求解',
      c: '代入公式計算'
    },
    tags: ['等比數列', '方程求解', '前n項和'],
    difficulty: 2,
    order: 2
  },
  {
    id: 'M12_04_P003',
    topicId: 'M12_04',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '數列的二次方程問題：',
    parts: {
      a: '等差數列 {aₙ} 的前n項和 Sₙ = an² + bn + c',
      b: '討論 {aₙ} 為等差數列的條件',
      c: '若 S₅ = 25，S₁₀ = 100，求 a, b, c'
    },
    solution: {
      a: '當 n = 1：a₁ = S₁ = a + b + c\n當 n ≥ 2：aₙ = Sₙ - Sₙ₋₁ = a[n² - (n-1)²] + b[n - (n-1)]\n= a(2n - 1) + b = 2an + (b - a)',
      b: '為等差數列需要 c = 0（使 a₁ 與通項一致）\n此時 aₙ = 2an + (b - a)，公差 d = 2a',
      c: '設 Sₙ = an² + bn（c = 0）\nS₅ = 25a + 5b = 25\nS₁₀ = 100a + 10b = 100\n解得：a = 1, b = 0\n因此 Sₙ = n²'
    },
    hint: {
      a: '利用前n項和與通項關係',
      b: '分析等差數列的必要條件',
      c: '建立方程組求解'
    },
    tags: ['等差數列', '二次方程', '前n項和'],
    difficulty: 3,
    order: 3
  },
  {
    id: 'M12_04_P004',
    topicId: 'M12_04',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '混合數列方程：',
    parts: {
      a: '數列 {aₙ} 滿足：aₙ₊₁ = 2aₙ + 3，a₁ = 1',
      b: '證明 {aₙ + 3} 是等比數列',
      c: '求 aₙ 的通項公式'
    },
    solution: {
      a: '遞推關係：aₙ₊₁ = 2aₙ + 3\n初始條件：a₁ = 1',
      b: '設 bₙ = aₙ + 3，則：\nbₙ₊₁ = aₙ₊₁ + 3 = 2aₙ + 3 + 3 = 2aₙ + 6 = 2(aₙ + 3) = 2bₙ\n因此 {bₙ} 是公比為2的等比數列',
      c: 'b₁ = a₁ + 3 = 4，所以 bₙ = 4 × 2ⁿ⁻¹ = 2ⁿ⁺¹\n因此 aₙ = bₙ - 3 = 2ⁿ⁺¹ - 3'
    },
    hint: {
      a: '理解遞推關係',
      b: '構造輔助數列',
      c: '利用等比數列求通項'
    },
    tags: ['遞推數列', '等比數列', '構造法'],
    difficulty: 3,
    order: 4
  },
  {
    id: 'M12_04_P005',
    topicId: 'M12_04',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '聯立數列方程：',
    parts: {
      a: '等差數列 {aₙ} 和等比數列 {bₙ} 滿足：a₁ = b₁ = 2，a₃ = b₃ = 8',
      b: '求兩數列的通項公式',
      c: '求滿足 aₙ = bₘ 的所有正整數對 (n,m)'
    },
    solution: {
      a: '等差數列：a₃ = a₁ + 2d = 2 + 2d = 8，得 d = 3\n等比數列：b₃ = b₁ × r² = 2r² = 8，得 r = 2',
      b: '等差數列：aₙ = 2 + (n-1)×3 = 3n - 1\n等比數列：bₘ = 2 × 2ᵐ⁻¹ = 2ᵐ',
      c: '要求 aₙ = bₘ：3n - 1 = 2ᵐ\n即 n = (2ᵐ + 1)/3\n當 m = 1：n = 1 ✓\n當 m = 3：n = 3 ✓\n當 m = 5：n = 11 ✓\n一般地：m = 2k+1 時，n = (2²ᵏ⁺¹ + 1)/3'
    },
    hint: {
      a: '分別求兩數列參數',
      b: '寫出通項公式',
      c: '建立方程求整數解'
    },
    tags: ['等差數列', '等比數列', '聯立方程'],
    difficulty: 3,
    order: 5
  }
];

// M12_05: 交錯級數 (5題)
export const M12_05_PROBLEMS = [
  {
    id: 'M12_05_P001',
    topicId: 'M12_05',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '交錯等比級數：',
    parts: {
      a: '級數 1 - 1/2 + 1/4 - 1/8 + 1/16 - ...',
      b: '判斷級數的收斂性',
      c: '求級數的和'
    },
    solution: {
      a: '這是首項 a₁ = 1，公比 r = -1/2 的等比級數\n通項：aₙ = 1 × (-1/2)ⁿ⁻¹ = (-1/2)ⁿ⁻¹',
      b: '收斂性判斷：|r| = |-1/2| = 1/2 < 1\n因此級數收斂',
      c: '級數和：S∞ = a₁/(1-r) = 1/(1-(-1/2)) = 1/(3/2) = 2/3'
    },
    hint: {
      a: '識別首項和公比',
      b: '檢查 |r| < 1',
      c: '使用無窮等比級數求和公式'
    },
    tags: ['交錯級數', '等比級數', '收斂性'],
    difficulty: 3,
    order: 1
  },
  {
    id: 'M12_05_P002',
    topicId: 'M12_05',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '交錯數列的前n項和：',
    parts: {
      a: '數列 {aₙ} 中，aₙ = (-1)ⁿ × n',
      b: '求前10項和 S₁₀',
      c: '求前n項和 Sₙ 的通項公式'
    },
    solution: {
      a: '數列項：a₁ = -1, a₂ = 2, a₃ = -3, a₄ = 4, a₅ = -5, ...\n正負交替，絕對值為自然數',
      b: 'S₁₀ = -1 + 2 - 3 + 4 - 5 + 6 - 7 + 8 - 9 + 10\n= (2-1) + (4-3) + (6-5) + (8-7) + (10-9)\n= 1 + 1 + 1 + 1 + 1 = 5',
      c: '當 n 為偶數時：Sₙ = n/2\n當 n 為奇數時：Sₙ = -(n+1)/2\n統一表示：Sₙ = (-1)ⁿ⁺¹ × ⌈n/2⌉'
    },
    hint: {
      a: '觀察項的符號規律',
      b: '配對相鄰項計算',
      c: '分奇偶討論'
    },
    tags: ['交錯數列', '前n項和', '符號規律'],
    difficulty: 3,
    order: 2
  },
  {
    id: 'M12_05_P003',
    topicId: 'M12_05',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '萊布尼茲級數：',
    parts: {
      a: '級數 1 - 1/3 + 1/5 - 1/7 + 1/9 - ...',
      b: '寫出通項公式',
      c: '分析級數的收斂性（不要求求和）'
    },
    solution: {
      a: '這是著名的萊布尼茲級數（π/4 級數）\n分母為奇數：1, 3, 5, 7, 9, ...',
      b: '通項公式：aₙ = (-1)ⁿ⁺¹ × 1/(2n-1)\n或 aₙ = (-1)ⁿ⁻¹ × 1/(2n-1)',
      c: '這是交錯級數，滿足萊布尼茲判別法：\n1) |aₙ| = 1/(2n-1) 單調遞減\n2) lim(n→∞) |aₙ| = 0\n因此級數收斂（收斂到 π/4）'
    },
    hint: {
      a: '觀察分母規律',
      b: '結合符號和分母規律',
      c: '應用萊布尼茲判別法'
    },
    tags: ['萊布尼茲級數', '交錯級數', '收斂判別'],
    difficulty: 3,
    order: 3
  },
  {
    id: 'M12_05_P004',
    topicId: 'M12_05',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '條件收斂級數：',
    parts: {
      a: '級數 Σ((-1)ⁿ⁺¹/n) = 1 - 1/2 + 1/3 - 1/4 + ...',
      b: '證明級數條件收斂',
      c: '比較前10項和與前20項和'
    },
    solution: {
      a: '這是調和級數的交錯形式\n通項：aₙ = (-1)ⁿ⁺¹/n',
      b: '條件收斂證明：\n1) 交錯級數收斂：|1/n| 遞減且趨於0\n2) 絕對級數發散：Σ(1/n) 為調和級數，發散\n因此級數條件收斂',
      c: 'S₁₀ = 1 - 1/2 + 1/3 - ... + 1/9 - 1/10 ≈ 0.6456\nS₂₀ = S₁₀ + 1/11 - 1/12 + ... + 1/19 - 1/20 ≈ 0.6687\n級數緩慢收斂到 ln(2) ≈ 0.6931'
    },
    hint: {
      a: '識別調和級數的交錯形式',
      b: '區分條件收斂和絕對收斂',
      c: '數值計算比較'
    },
    tags: ['條件收斂', '調和級數', '交錯級數'],
    difficulty: 3,
    order: 4
  },
  {
    id: 'M12_05_P005',
    topicId: 'M12_05',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '交錯數列的實際應用：',
    parts: {
      a: '某投資每月收益交替為正負：第1月 +1000元，第2月 -800元，第3月 +1000元，第4月 -800元...',
      b: '建立數列模型',
      c: '求前24個月的總收益'
    },
    solution: {
      a: '收益數列：+1000, -800, +1000, -800, ...\n這是周期為2的交錯數列',
      b: '數列模型：aₙ = 1000 × (-1)ⁿ⁺¹ × 0.8ⁿ⁻¹ + 200 × (-1)ⁿ⁺¹\n簡化：奇數月 +1000，偶數月 -800',
      c: '24個月包含12個周期\n每個周期收益：1000 + (-800) = 200元\n總收益：12 × 200 = 2400元'
    },
    hint: {
      a: '觀察收益的周期性',
      b: '建立周期數列模型',
      c: '利用周期性計算'
    },
    tags: ['交錯數列', '周期數列', '實際應用'],
    difficulty: 3,
    order: 5
  }
];

// M12_06: 因數分解 (5題)
export const M12_06_PROBLEMS = [
  {
    id: 'M12_06_P001',
    topicId: 'M12_06',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等比數列的因數分解應用：',
    parts: {
      a: '等比數列前n項和 Sₙ = 3ⁿ - 1',
      b: '求通項公式 aₙ',
      c: '驗證結果並求公比'
    },
    solution: {
      a: '當 n = 1：a₁ = S₁ = 3¹ - 1 = 2\n當 n ≥ 2：aₙ = Sₙ - Sₙ₋₁',
      b: 'aₙ = (3ⁿ - 1) - (3ⁿ⁻¹ - 1) = 3ⁿ - 3ⁿ⁻¹\n= 3ⁿ⁻¹(3 - 1) = 2 × 3ⁿ⁻¹\n檢驗 n = 1：a₁ = 2 × 3⁰ = 2 ✓',
      c: '通項公式：aₙ = 2 × 3ⁿ⁻¹\n公比：r = aₙ₊₁/aₙ = (2 × 3ⁿ)/(2 × 3ⁿ⁻¹) = 3'
    },
    hint: {
      a: '分別計算 n=1 和 n≥2 的情況',
      b: '利用因數分解化簡',
      c: '驗證通項公式的正確性'
    },
    tags: ['等比數列', '因數分解', '前n項和'],
    difficulty: 2,
    order: 1
  },
  {
    id: 'M12_06_P002',
    topicId: 'M12_06',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '平方差公式在數列中的應用：',
    parts: {
      a: '計算：1² - 2² + 3² - 4² + 5² - 6² + ... + 99² - 100²',
      b: '利用平方差公式分解',
      c: '求最終結果'
    },
    solution: {
      a: '將相鄰項配對：(1² - 2²) + (3² - 4²) + ... + (99² - 100²)\n共50對',
      b: '利用平方差公式 a² - b² = (a+b)(a-b)：\n1² - 2² = (1+2)(1-2) = 3×(-1) = -3\n3² - 4² = (3+4)(3-4) = 7×(-1) = -7\n...\n99² - 100² = (99+100)(99-100) = 199×(-1) = -199',
      c: '總和 = -3 - 7 - 11 - ... - 199\n= -(3 + 7 + 11 + ... + 199)\n這是首項3，公差4，項數50的等差數列\n和 = 50/2 × (3 + 199) = 25 × 202 = 5050\n因此原式 = -5050'
    },
    hint: {
      a: '將項配對處理',
      b: '應用平方差公式',
      c: '識別等差數列求和'
    },
    tags: ['平方差公式', '因數分解', '等差數列'],
    difficulty: 2,
    order: 2
  },
  {
    id: 'M12_06_P003',
    topicId: 'M12_06',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '立方和與立方差：',
    parts: {
      a: '計算：1³ + 2³ + 3³ + ... + n³',
      b: '利用 (1 + 2 + ... + n)² 的關係',
      c: '驗證 n = 5 的情況'
    },
    solution: {
      a: '立方和公式推導：利用恆等式\n1³ + 2³ + ... + n³ = [n(n+1)/2]²',
      b: '證明：1 + 2 + ... + n = n(n+1)/2\n因此 (1 + 2 + ... + n)² = [n(n+1)/2]²\n這正好等於立方和',
      c: '驗證 n = 5：\n左邊：1³ + 2³ + 3³ + 4³ + 5³ = 1 + 8 + 27 + 64 + 125 = 225\n右邊：[5×6/2]² = 15² = 225 ✓'
    },
    hint: {
      a: '記住立方和公式',
      b: '利用自然數和的平方',
      c: '代入具體數值驗證'
    },
    tags: ['立方和', '因數分解', '恆等式'],
    difficulty: 2,
    order: 3
  },
  {
    id: 'M12_06_P004',
    topicId: 'M12_06',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '複雜因式分解：',
    parts: {
      a: '分解：aⁿ - bⁿ (n為正整數)',
      b: '當 n = 6 時的具體分解',
      c: '應用於等比數列求和公式的推導'
    },
    solution: {
      a: '當 n 為任意正整數：\naⁿ - bⁿ = (a - b)(aⁿ⁻¹ + aⁿ⁻²b + aⁿ⁻³b² + ... + abⁿ⁻² + bⁿ⁻¹)',
      b: 'a⁶ - b⁶ = (a - b)(a⁵ + a⁴b + a³b² + a²b³ + ab⁴ + b⁵)\n也可以：a⁶ - b⁶ = (a²)³ - (b²)³ = (a² - b²)(a⁴ + a²b² + b⁴)\n進一步：= (a - b)(a + b)(a⁴ + a²b² + b⁴)',
      c: '等比數列求和：Sₙ = a + ar + ar² + ... + arⁿ⁻¹\n乘以 r：rSₙ = ar + ar² + ... + arⁿ\n相減：Sₙ - rSₙ = a - arⁿ = a(1 - rⁿ)\n因此：Sₙ = a(1 - rⁿ)/(1 - r)'
    },
    hint: {
      a: '記住一般分解公式',
      b: '可以多種方式分解',
      c: '理解求和公式的推導過程'
    },
    tags: ['因式分解', '等比數列', '求和公式'],
    difficulty: 3,
    order: 4
  },
  {
    id: 'M12_06_P005',
    topicId: 'M12_06',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '數列中的因式定理：',
    parts: {
      a: '若 x - 2 是多項式 f(x) = xⁿ - 2ⁿ 的因式',
      b: '利用因式定理驗證',
      c: '將此結果應用於數列 {2ⁿ} 的性質研究'
    },
    solution: {
      a: '根據因式定理：若 x - a 是 f(x) 的因式，則 f(a) = 0\n檢驗：f(2) = 2ⁿ - 2ⁿ = 0 ✓',
      b: '因式分解：xⁿ - 2ⁿ = (x - 2)(xⁿ⁻¹ + 2xⁿ⁻² + 2²xⁿ⁻³ + ... + 2ⁿ⁻²x + 2ⁿ⁻¹)',
      c: '應用於數列：當 x = 2 時，分解式中的第二個因子為：\n2ⁿ⁻¹ + 2×2ⁿ⁻² + 2²×2ⁿ⁻³ + ... + 2ⁿ⁻²×2 + 2ⁿ⁻¹\n= n×2ⁿ⁻¹\n這給出恆等式：n×2ⁿ⁻¹ = (2ⁿ - 2ⁿ)/(2 - 2) (形式上)'
    },
    hint: {
      a: '應用因式定理判定',
      b: '寫出完整的因式分解',
      c: '探索與數列的聯繫'
    },
    tags: ['因式定理', '多項式', '數列性質'],
    difficulty: 3,
    order: 5
  }
];

// M12_07: 折舊計算 (5題)
export const M12_07_PROBLEMS = [
  {
    id: 'M12_07_P001',
    topicId: 'M12_07',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '設備的等比折舊：',
    parts: {
      a: '某設備原值50萬元，每年折舊15%',
      b: '求6年後的賬面價值',
      c: '何時賬面價值降至原值的一半'
    },
    solution: {
      a: '每年保留85%的價值，形成等比數列\n通項公式：Vₙ = 50 × 0.85ⁿ⁻¹（第n年初的價值）\n或 Vₙ = 50 × 0.85ⁿ（第n年末的價值）',
      b: '6年後（第6年末）：V₆ = 50 × 0.85⁶\n0.85⁶ ≈ 0.3771\nV₆ ≈ 50 × 0.3771 = 18.86萬元',
      c: '設第n年末價值降至25萬元：\n50 × 0.85ⁿ = 25\n0.85ⁿ = 0.5\nn log(0.85) = log(0.5)\nn = log(0.5)/log(0.85) ≈ 4.27年'
    },
    hint: {
      a: '識別等比數列模型',
      b: '計算指定年份的價值',
      c: '利用對數求解'
    },
    tags: ['折舊計算', '等比數列', '實際應用'],
    difficulty: 2,
    order: 1
  },
  {
    id: 'M12_07_P002',
    topicId: 'M12_07',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '累計折舊額計算：',
    parts: {
      a: '設備原值100萬元，每年折舊率20%',
      b: '求前5年的累計折舊額',
      c: '求第n年的折舊額通項公式'
    },
    solution: {
      a: '每年賬面價值：V₀ = 100, V₁ = 80, V₂ = 64, V₃ = 51.2, V₄ = 40.96, V₅ = 32.768\n年折舊額：D₁ = 20, D₂ = 16, D₃ = 12.8, D₄ = 10.24, D₅ = 8.192',
      b: '累計折舊額 = 原值 - 現值 = 100 - 32.768 = 67.232萬元\n或直接求和：20 + 16 + 12.8 + 10.24 + 8.192 = 67.232萬元',
      c: '第n年折舊額：Dₙ = 100 × 0.2 × 0.8ⁿ⁻¹ = 20 × 0.8ⁿ⁻¹\n這是首項20，公比0.8的等比數列'
    },
    hint: {
      a: '計算每年的價值和折舊額',
      b: '用兩種方法驗證',
      c: '找出折舊額的規律'
    },
    tags: ['累計折舊', '等比數列', '財務計算'],
    difficulty: 2,
    order: 2
  },
  {
    id: 'M12_07_P003',
    topicId: 'M12_07',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '設備更新決策：',
    parts: {
      a: '設備原值60萬，每年價值減少25%，維修費第1年2萬，之後每年增加50%',
      b: '建立總成本模型',
      c: '確定最佳更新時間（總成本最低）'
    },
    solution: {
      a: '設備價值：Vₙ = 60 × 0.75ⁿ\n維修費：Mₙ = 2 × 1.5ⁿ⁻¹\n使用n年的總成本 = 購置成本 - 殘值 + 維修費總和',
      b: '總成本：Cₙ = 60 - 60×0.75ⁿ + 2×(1.5ⁿ-1)/(1.5-1)\n= 60 - 60×0.75ⁿ + 4×(1.5ⁿ-1)\n= 56 - 60×0.75ⁿ + 4×1.5ⁿ',
      c: '平均年成本：C̄ₙ = Cₙ/n\n通過計算不同n值：\nn=1: C̄₁ = 47萬/年\nn=2: C̄₂ = 35.75萬/年\nn=3: C̄₃ = 32.67萬/年\nn=4: C̄₄ = 33.44萬/年\n最佳更新時間約為第3年'
    },
    hint: {
      a: '分別建立價值和維修費模型',
      b: '考慮購置成本、殘值和維修費',
      c: '計算平均年成本找最小值'
    },
    tags: ['設備更新', '成本分析', '決策優化'],
    difficulty: 3,
    order: 3
  },
  {
    id: 'M12_07_P004',
    topicId: 'M12_07',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '加速折舊法：',
    parts: {
      a: '設備原值80萬，採用雙倍餘額遞減法，使用年限8年',
      b: '計算前3年的折舊額',
      c: '比較與直線折舊法的差異'
    },
    solution: {
      a: '雙倍餘額遞減法：年折舊率 = 2/使用年限 = 2/8 = 25%\n第1年：D₁ = 80 × 25% = 20萬\n第2年：D₂ = (80-20) × 25% = 15萬\n第3年：D₃ = (80-35) × 25% = 11.25萬',
      b: '前3年折舊額：20, 15, 11.25萬元\n累計折舊：46.25萬元\n賬面價值：80 - 46.25 = 33.75萬元',
      c: '直線折舊法：每年折舊 = 80/8 = 10萬元\n前3年累計：30萬元\n差異：46.25 - 30 = 16.25萬元\n加速折舊法前期折舊更多，有稅收優勢'
    },
    hint: {
      a: '理解雙倍餘額遞減法',
      b: '逐年計算折舊額',
      c: '與直線法比較分析'
    },
    tags: ['加速折舊', '雙倍餘額', '稅收優化'],
    difficulty: 3,
    order: 4
  },
  {
    id: 'M12_07_P005',
    topicId: 'M12_07',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '折舊與投資回報：',
    parts: {
      a: '設備投資120萬，每年收益30萬，每年折舊10%',
      b: '考慮折舊後的淨現值分析',
      c: '確定投資回收期'
    },
    solution: {
      a: '設備價值：Vₙ = 120 × 0.9ⁿ\n年收益：30萬（固定）\n年折舊額：第n年為 120×0.1×0.9ⁿ⁻¹',
      b: '考慮貨幣時間價值（假設折現率5%）：\n第n年淨現金流現值 = 30/(1.05)ⁿ\n累計現值：NPV = Σ[30/(1.05)ⁿ] - 120\n當NPV > 0時投資可行',
      c: '不考慮折現的回收期：120/30 = 4年\n考慮折現：需要計算使累計現值等於初始投資的年數\n通過計算約需4.5年回收投資'
    },
    hint: {
      a: '建立收益和折舊模型',
      b: '考慮貨幣時間價值',
      c: '計算投資回收期'
    },
    tags: ['投資回報', '淨現值', '回收期'],
    difficulty: 3,
    order: 5
  }
];

// M12_08: 求和公式 (5題)
export const M12_08_PROBLEMS = [
  {
    id: 'M12_08_P001',
    topicId: 'M12_08',
    type: 'multi_part',
    difficulty: 'basic',
    question: '等差數列求和公式應用：',
    parts: {
      a: '等差數列 {aₙ} 中，a₁ = 5，d = 3',
      b: '求前20項的和 S₂₀',
      c: '求使 Sₙ > 500 的最小正整數 n'
    },
    solution: {
      a: '等差數列求和公式：Sₙ = n/2 × [2a₁ + (n-1)d]\n或 Sₙ = n/2 × (a₁ + aₙ)',
      b: 'S₂₀ = 20/2 × [2×5 + 19×3] = 10 × (10 + 57) = 670',
      c: 'Sₙ = n/2 × [10 + 3(n-1)] = n/2 × (3n + 7) = (3n² + 7n)/2\n要使 Sₙ > 500：(3n² + 7n)/2 > 500\n3n² + 7n > 1000\n3n² + 7n - 1000 > 0\n解得 n > 17.7，最小正整數 n = 18'
    },
    hint: {
      a: '記住等差數列求和公式',
      b: '直接代入公式計算',
      c: '建立不等式求解'
    },
    tags: ['等差數列', '求和公式', '不等式'],
    difficulty: 1,
    order: 1
  },
  {
    id: 'M12_08_P002',
    topicId: 'M12_08',
    type: 'multi_part',
    difficulty: 'basic',
    question: '等比數列求和公式應用：',
    parts: {
      a: '等比數列 {aₙ} 中，a₁ = 3，r = 2',
      b: '求前8項的和 S₈',
      c: '求前n項和的通項公式'
    },
    solution: {
      a: '等比數列求和公式：Sₙ = a₁(rⁿ - 1)/(r - 1) (r ≠ 1)\n或 Sₙ = a₁(1 - rⁿ)/(1 - r)',
      b: 'S₈ = 3(2⁸ - 1)/(2 - 1) = 3(256 - 1) = 3 × 255 = 765',
      c: '前n項和：Sₙ = 3(2ⁿ - 1)/(2 - 1) = 3(2ⁿ - 1)'
    },
    hint: {
      a: '記住等比數列求和公式',
      b: '計算2的8次方',
      c: '寫出一般形式'
    },
    tags: ['等比數列', '求和公式', '通項公式'],
    difficulty: 1,
    order: 2
  },
  {
    id: 'M12_08_P003',
    topicId: 'M12_08',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '特殊數列求和：',
    parts: {
      a: '計算：1 + 3 + 5 + 7 + ... + (2n-1)',
      b: '計算：1² + 3² + 5² + ... + (2n-1)²',
      c: '找出兩個和之間的關係'
    },
    solution: {
      a: '奇數數列：首項1，公差2，項數n\nS₁ = n/2 × [2×1 + (n-1)×2] = n/2 × 2n = n²',
      b: '奇數平方和：利用公式\n1² + 3² + 5² + ... + (2n-1)² = n(2n-1)(2n+1)/3\n這是前n個奇數平方的和',
      c: '關係分析：\n奇數和 = n²\n奇數平方和 = n(2n-1)(2n+1)/3 = n(4n²-1)/3\n比值：[n(4n²-1)/3]/n² = (4n²-1)/(3n) = 4n/3 - 1/(3n)'
    },
    hint: {
      a: '識別為等差數列',
      b: '使用奇數平方和公式',
      c: '分析兩個和的關係'
    },
    tags: ['特殊數列', '奇數數列', '平方和'],
    difficulty: 2,
    order: 3
  },
  {
    id: 'M12_08_P004',
    topicId: 'M12_08',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '數列求和的巧妙方法：',
    parts: {
      a: '計算：S = 1×2 + 2×3 + 3×4 + ... + n(n+1)',
      b: '利用裂項相消法',
      c: '驗證結果'
    },
    solution: {
      a: '通項：aₖ = k(k+1) = k² + k\nS = Σk² + Σk = n(n+1)(2n+1)/6 + n(n+1)/2',
      b: '裂項法：k(k+1) = k(k+1)(k+2)/3 - (k-1)k(k+1)/3\n但更簡單的是：k(k+1) = [k(k+1)(k+2) - (k-1)k(k+1)]/3\n實際上：aₖ = k(k+1) = (1/3)[k(k+1)(k+2) - (k-1)k(k+1)]',
      c: 'S = (1/3) × n(n+1)(n+2)/3 = n(n+1)(n+2)/3\n驗證：當n=3時，S = 1×2 + 2×3 + 3×4 = 2 + 6 + 12 = 20\n公式：3×4×5/3 = 20 ✓'
    },
    hint: {
      a: '分解為平方和與自然數和',
      b: '尋找裂項規律',
      c: '用具體例子驗證'
    },
    tags: ['數列求和', '裂項相消', '組合技巧'],
    difficulty: 2,
    order: 4
  },
  {
    id: 'M12_08_P005',
    topicId: 'M12_08',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '復合數列求和：',
    parts: {
      a: '數列 {aₙ} 中，aₙ = n × 2ⁿ',
      b: '求前n項和 Sₙ',
      c: '利用錯位相減法求解'
    },
    solution: {
      a: '數列：1×2¹, 2×2², 3×2³, ..., n×2ⁿ\n這是自然數列與等比數列的乘積',
      b: 'Sₙ = 1×2 + 2×4 + 3×8 + ... + n×2ⁿ\n錯位相減法：\nSₙ = 1×2¹ + 2×2² + 3×2³ + ... + n×2ⁿ\n2Sₙ = 1×2² + 2×2³ + 3×2⁴ + ... + n×2ⁿ⁺¹',
      c: '相減：Sₙ - 2Sₙ = 2¹ + 2² + 2³ + ... + 2ⁿ - n×2ⁿ⁺¹\n-Sₙ = 2(2ⁿ-1)/(2-1) - n×2ⁿ⁺¹ = 2ⁿ⁺¹ - 2 - n×2ⁿ⁺¹\n= 2ⁿ⁺¹(1-n) - 2\nSₙ = (n-1)×2ⁿ⁺¹ + 2'
    },
    hint: {
      a: '識別復合數列類型',
      b: '寫出求和表達式',
      c: '掌握錯位相減法'
    },
    tags: ['復合數列', '錯位相減', '求和技巧'],
    difficulty: 3,
    order: 5
  }
];

// M12_09: 求和公式逆推 (5題)
export const M12_09_PROBLEMS = [
  {
    id: 'M12_09_P001',
    topicId: 'M12_09',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '已知數列前n項和求通項公式：',
    parts: {
      a: '已知等差數列 {aₙ} 的前n項和 Sₙ = 2n² + 3n',
      b: '求通項公式 aₙ',
      c: '驗證結果並求首項和公差'
    },
    solution: {
      a: '當n=1時：S₁ = a₁ = 2(1)² + 3(1) = 5\\n當n≥2時：aₙ = Sₙ - Sₙ₋₁',
      b: 'aₙ = Sₙ - Sₙ₋₁ = (2n² + 3n) - [2(n-1)² + 3(n-1)]\\n= 2n² + 3n - 2(n² - 2n + 1) - 3n + 3\\n= 2n² + 3n - 2n² + 4n - 2 - 3n + 3 = 4n + 1',
      c: '檢驗n=1：a₁ = 4(1) + 1 = 5 ✓\\n通項公式：aₙ = 4n + 1\\n首項a₁ = 5，公差d = 4'
    },
    hint: {
      a: '先求第一項',
      b: '用Sₙ - Sₙ₋₁求通項',
      c: '檢驗n=1的情況'
    },
    tags: ['前n項和', '通項公式', '等差數列'],
    difficulty: 4,
    order: 1
  },
  {
    id: 'M12_09_P002',
    topicId: 'M12_09',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '等比數列前n項和逆推：',
    parts: {
      a: '已知等比數列 {aₙ} 的前n項和 Sₙ = 3ⁿ⁺¹ - 3',
      b: '求通項公式 aₙ',
      c: '求首項和公比'
    },
    solution: {
      a: '當n=1時：S₁ = a₁ = 3² - 3 = 6\\n當n≥2時：aₙ = Sₙ - Sₙ₋₁',
      b: 'aₙ = (3ⁿ⁺¹ - 3) - (3ⁿ - 3) = 3ⁿ⁺¹ - 3ⁿ = 3ⁿ(3 - 1) = 2 × 3ⁿ',
      c: '檢驗n=1：a₁ = 2 × 3¹ = 6 ✓\\n首項a₁ = 6，公比r = 3'
    },
    hint: {
      a: '計算第一項的值',
      b: '用差分法求通項',
      c: '驗證並確定參數'
    },
    tags: ['等比數列', '前n項和', '逆推'],
    difficulty: 4,
    order: 2
  },
  {
    id: 'M12_09_P003',
    topicId: 'M12_09',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '分段數列的前n項和：',
    parts: {
      a: '已知數列前n項和 Sₙ = n² + 2n (n≤5), Sₙ = 35 + 7(n-5) (n>5)',
      b: '求通項公式 aₙ',
      c: '分析數列的性質'
    },
    solution: {
      a: '分兩段討論：\\n第一段(n≤5)：Sₙ = n² + 2n\\n第二段(n>5)：Sₙ = 35 + 7(n-5) = 7n',
      b: '當n≤5時：aₙ = Sₙ - Sₙ₋₁ = (n² + 2n) - [(n-1)² + 2(n-1)] = 2n + 1\\n當n>5時：aₙ = 7n - 7(n-1) = 7\\n所以aₙ = {2n+1 (n≤5), 7 (n>5)}',
      c: '前5項：3, 5, 7, 9, 11 (等差數列，d=2)\\n第6項起：7, 7, 7, ... (常數列)\\n在n=5到n=6之間數列性質發生變化'
    },
    hint: {
      a: '注意分段函數',
      b: '分別處理兩段',
      c: '觀察數列的不同性質'
    },
    tags: ['分段數列', '前n項和', '性質分析'],
    difficulty: 4,
    order: 3
  },
  {
    id: 'M12_09_P004',
    topicId: 'M12_09',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '複雜前n項和的處理：',
    parts: {
      a: '已知 Sₙ = n³ - n',
      b: '求通項公式 aₙ',
      c: '找出數列的規律'
    },
    solution: {
      a: '當n=1時：S₁ = a₁ = 1³ - 1 = 0\\n當n≥2時：aₙ = Sₙ - Sₙ₋₁',
      b: 'aₙ = (n³ - n) - [(n-1)³ - (n-1)]\\n= n³ - n - (n³ - 3n² + 3n - 1) + n - 1\\n= 3n² - 3n = 3n(n-1)',
      c: '檢驗n=1：a₁ = 3(1)(0) = 0 ✓\\n通項公式：aₙ = 3n(n-1)\\n規律：aₙ = 3n² - 3n，為二次函數形式'
    },
    hint: {
      a: '計算首項',
      b: '展開並化簡差分',
      c: '觀察通項的結構'
    },
    tags: ['立方和', '二次通項', '規律發現'],
    difficulty: 4,
    order: 4
  },
  {
    id: 'M12_09_P005',
    topicId: 'M12_09',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '含參數的前n項和：',
    parts: {
      a: '已知 Sₙ = an² + bn + c，且 S₁ = 2, S₂ = 8, S₃ = 18',
      b: '求參數 a, b, c',
      c: '求通項公式並驗證'
    },
    solution: {
      a: '建立方程組：\\nS₁ = a + b + c = 2\\nS₂ = 4a + 2b + c = 8\\nS₃ = 9a + 3b + c = 18',
      b: '解方程組：\\n第二式減第一式：3a + b = 6\\n第三式減第二式：5a + b = 10\\n相減得：2a = 4，所以a = 2\\n代入得：b = 0, c = 0',
      c: 'Sₙ = 2n²\\n通項公式：a₁ = S₁ = 2\\naₙ = Sₙ - Sₙ₋₁ = 2n² - 2(n-1)² = 4n - 2 (n≥2)\\n檢驗：a₁ = 2, a₂ = 6, a₃ = 10，S₃ = 2+6+10 = 18 ✓'
    },
    hint: {
      a: '用已知條件建立方程組',
      b: '逐步消元求解',
      c: '求通項並驗證結果'
    },
    tags: ['參數求解', '方程組', '通項驗證'],
    difficulty: 4,
    order: 5
  }
];

// M12_10: 求和公式應用 (5題)
export const M12_10_PROBLEMS = [
  {
    id: 'M12_10_P001',
    topicId: 'M12_10',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等差數列求和的實際應用：',
    parts: {
      a: '某公司第一年利潤100萬元，以後每年比前一年增加20萬元',
      b: '求前10年的總利潤',
      c: '第幾年開始年利潤超過300萬元？'
    },
    solution: {
      a: '這是等差數列：a₁ = 100，d = 20\\n第n年利潤：aₙ = 100 + (n-1)×20 = 80 + 20n',
      b: '前10年總利潤：S₁₀ = 10×100 + (10×9/2)×20 = 1000 + 900 = 1900萬元',
      c: '要求aₙ > 300：80 + 20n > 300\\n20n > 220，n > 11\\n所以第12年開始年利潤超過300萬元'
    },
    hint: {
      a: '識別等差數列模式',
      b: '使用等差數列求和公式',
      c: '建立不等式求解'
    },
    tags: ['等差數列', '實際應用', '利潤計算'],
    difficulty: 3,
    order: 1
  },
  {
    id: 'M12_10_P002',
    topicId: 'M12_10',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等比數列求和的金融應用：',
    parts: {
      a: '某人每年年初存款1萬元，銀行年利率5%，複利計算',
      b: '求10年後的總存款額',
      c: '如果目標是50萬元，需要存多少年？'
    },
    solution: {
      a: '每年存款在第n年末的價值：1×(1.05)ⁿ萬元\\n這形成等比數列：a₁ = 1.05, r = 1.05',
      b: '10年後總額：S₁₀ = 1.05×(1.05¹⁰-1)/(1.05-1) = 1.05×(1.6289-1)/0.05 ≈ 13.21萬元',
      c: '設需要n年：1.05×(1.05ⁿ-1)/0.05 = 50\\n1.05ⁿ - 1 = 2.381\\n1.05ⁿ = 3.381\\nn = log(3.381)/log(1.05) ≈ 25年'
    },
    hint: {
      a: '考慮複利效應',
      b: '使用等比數列求和公式',
      c: '解指數方程'
    },
    tags: ['等比數列', '複利計算', '金融應用'],
    difficulty: 3,
    order: 2
  },
  {
    id: 'M12_10_P003',
    topicId: 'M12_10',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '混合數列的求和應用：',
    parts: {
      a: '某項工程，第1天完成總工程的1/20，以後每天比前一天多完成1/100',
      b: '求前5天完成的工程比例',
      c: '工程能否在15天內完成？'
    },
    solution: {
      a: '每天完成比例形成等差數列：a₁ = 1/20 = 0.05，d = 1/100 = 0.01\\n第n天完成比例：aₙ = 0.05 + (n-1)×0.01 = 0.04 + 0.01n',
      b: '前5天總比例：S₅ = 5×0.05 + (5×4/2)×0.01 = 0.25 + 0.1 = 0.35\\n即完成35%的工程',
      c: '前15天總比例：S₁₅ = 15×0.05 + (15×14/2)×0.01 = 0.75 + 1.05 = 1.8\\n由於1.8 > 1，所以工程在15天內可以完成'
    },
    hint: {
      a: '識別等差數列',
      b: '計算前n項和',
      c: '判斷總和是否超過1'
    },
    tags: ['等差數列', '工程問題', '比例計算'],
    difficulty: 3,
    order: 3
  },
  {
    id: 'M12_10_P004',
    topicId: 'M12_10',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '人口增長模型的求和：',
    parts: {
      a: '某城市現有人口50萬，每年增長率為3%',
      b: '求未來10年的人口總和',
      c: '分析人口增長的累積效應'
    },
    solution: {
      a: '第n年人口：Pₙ = 50×(1.03)ⁿ萬人\\n這是等比數列：a₁ = 50×1.03 = 51.5，r = 1.03',
      b: '10年人口總和：S₁₀ = 51.5×(1.03¹⁰-1)/(1.03-1) = 51.5×(1.3439-1)/0.03 ≈ 590.2萬人年',
      c: '累積效應：平均每年人口約59萬人\\n比初始人口50萬增加18%\\n指數增長使後期人口貢獻更大'
    },
    hint: {
      a: '識別指數增長模式',
      b: '使用等比數列求和',
      c: '分析增長的累積特點'
    },
    tags: ['等比數列', '人口增長', '指數模型'],
    difficulty: 4,
    order: 4
  },
  {
    id: 'M12_10_P005',
    topicId: 'M12_10',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '分期付款的求和計算：',
    parts: {
      a: '購房貸款100萬元，年利率6%，分20年等額還款',
      b: '計算每月還款額',
      c: '求20年總還款額和利息總額'
    },
    solution: {
      a: '月利率r = 6%/12 = 0.5%\\n設每月還款額為A\\n貸款餘額遞減形成等比數列關係',
      b: '等額還款公式：A = P×r×(1+r)ⁿ/[(1+r)ⁿ-1]\\n其中P=100萬，r=0.005，n=240\\nA = 100×0.005×1.005²⁴⁰/(1.005²⁴⁰-1) ≈ 0.716萬元/月',
      c: '20年總還款：240×0.716 = 171.84萬元\\n利息總額：171.84 - 100 = 71.84萬元\\n利息占貸款額的71.84%'
    },
    hint: {
      a: '理解等額還款機制',
      b: '使用等額還款公式',
      c: '計算總額和利息'
    },
    tags: ['等比數列', '貸款計算', '金融數學'],
    difficulty: 4,
    order: 5
  }
];

// 導出所有問題數據
export const M12_TOPICS_03_10_PROBLEMS = [
  ...M12_03_PROBLEMS,
  ...M12_04_PROBLEMS,
  ...M12_05_PROBLEMS,
  ...M12_06_PROBLEMS,
  ...M12_07_PROBLEMS,
  ...M12_08_PROBLEMS
];

// 主題信息
export const M12_TOPICS_03_10_INFO = [
  {
    id: 'M12_03',
    title: '公差計算',
    description: '運用等差數列性質計算公差',
    difficulty: 'basic',
    estimatedMinutes: 25,
    order: 3
  },
  {
    id: 'M12_04',
    title: '方程求解',
    description: '建立數列方程並求解未知數',
    difficulty: 'intermediate',
    estimatedMinutes: 40,
    order: 4
  },
  {
    id: 'M12_05',
    title: '交錯級數',
    description: '處理正負交替的級數問題',
    difficulty: 'advanced',
    estimatedMinutes: 45,
    order: 5
  },
  {
    id: 'M12_06',
    title: '因數分解',
    description: '運用因數分解處理數列問題',
    difficulty: 'intermediate',
    estimatedMinutes: 35,
    order: 6
  },
  {
    id: 'M12_07',
    title: '折舊計算',
    description: '應用等比數列解決折舊問題',
    difficulty: 'intermediate',
    estimatedMinutes: 40,
    order: 7
  },
  {
    id: 'M12_08',
    title: '求和公式',
    description: '掌握等差和等比數列求和公式',
    difficulty: 'basic',
    estimatedMinutes: 30,
    order: 8
  },
  {
    id: 'M12_09',
    title: '求和公式逆推',
    description: '從前n項和逆推通項公式',
    difficulty: 'advanced',
    estimatedMinutes: 50,
    order: 9
  },
  {
    id: 'M12_10',
    title: '求和公式應用',
    description: '運用求和公式解決實際問題',
    difficulty: 'intermediate',
    estimatedMinutes: 45,
    order: 10
  }
]; 